import { Factory } from 'miragejs'
import { faker } from '@faker-js/faker'

type Bucket = {
    name: string
    creationDate: Date
    objectsCount: number
    size: number
}

export const bucketFactory = Factory.extend<Bucket>({
    name() {
        return faker.lorem.word()
    },
    creationDate() {
        return faker.date.recent()
    },
    objectsCount() {
        return faker.number.int({ min: 0, max: 5000 })
    },
    size() {
        return faker.number.int({ min: 100, max: 5000 })
    },
})
